import { combineReducers } from 'redux';
import { tourSearchReducer } from './tours/tourSearchOperations';
import { commonSearchReducer } from './common/commonSearchOperations';

export const combinedSearchReducers = combineReducers({
  tours: tourSearchReducer,
  common: commonSearchReducer
});
